var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKorpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.8 25.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "korpa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.69,21.44a1.88,1.88,0,1,0,1.89,1.88A1.88,1.88,0,0,0,18.69,21.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.48,21.44a1.88,1.88,0,1,0,1.88,1.88A1.89,1.89,0,0,0,11.48,21.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,4.75H6.31L5.78.81a.84.84,0,0,0-1-.81H.94a.94.94,0,0,0,0,1.88H4l2.21,13.4c.36,2.31.89,4.54,3.89,4.54H20.47c3,0,3.37-2.17,3.91-4.35l2.31-9.24C26.87,5.51,26.92,4.75,26,4.75ZM24.11,9H11.29a1,1,0,0,0-.94.94h0a1,1,0,0,0,.94.94H23.64l-.54,2.15H13.59a1,1,0,0,0-.94.94h0a1,1,0,0,0,.94.94h9l-.1.4c-.29,1.19-.36,2.6-2.06,2.6H10.11c-1.8,0-1.84-1.61-2.06-2.89L6.65,6.63H24.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorpa);
export default __webpack_public_path__ + "static/media/korpa.e2d38159985675b9a4f371e617fdaaee.svg";
export { ForwardRef as ReactComponent };